/** Bump whenever a release changes runtime code or the fixed production atlas. */
export const APP_BUILD_VERSION = "2026-10-12.5";
